import * as React from "react";
function SvgInstagramBusiness(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M24.1 17c-.3 0-.6.3-.6.6v2.5h-15v-2.5c0-.3-.3-.6-.6-.6s-.6.3-.6.6v6.3c0 .6.6 1.2 1.2 1.2h15c.7 0 1.2-.5 1.2-1.2v-6.2c0-.4-.3-.7-.6-.7zM8.5 23.8v-2.5h15v2.5h-15zM26 12.1c0-.2 0-.3-.1-.5l-3.2-4.5c-.1-.2-.3-.2-.5-.2H9.7c-.2 0-.3.1-.5.3l-3.1 4.5c-.1.1-.1.2-.1.4v1.2c0 1.6 1.2 3 2.9 3h.2c.9 0 1.7-.5 2.3-1.2.5.7 1.3 1.2 2.3 1.2h.2c.9 0 1.7-.5 2.2-1.2.5.7 1.3 1.1 2.2 1.2h.2c.9 0 1.7-.5 2.2-1.2.5.7 1.3 1.1 2.2 1.2h.2c1.6 0 2.9-1.4 2.8-3v-1.2h.1zm-2.9 3h-.2c-.9 0-1.7-.8-1.6-1.7v-.2s0-.1-.1-.1c0 0 0-.1-.1-.1H21v-.1h-.5s-.1.1-.2.1l-.1.1v.2c0 .9-.7 1.7-1.6 1.7h-.2c-.9 0-1.7-.8-1.6-1.7 0-.3-.2-.5-.4-.6H16.1c-.2.1-.4.3-.4.6 0 .9-.7 1.7-1.6 1.7h-.2c-.9 0-1.7-.8-1.6-1.7 0-.3-.2-.6-.6-.6h-.2c-.3 0-.6.3-.6.6 0 .9-.7 1.7-1.6 1.7h-.5c-.9 0-1.7-.8-1.6-1.7v-1.1l2.9-4h11.8l2.8 4v1.1c.1 1-.7 1.7-1.6 1.8z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgInstagramBusiness);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
